<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { ColorPicker } from 'vue-color-kit'
  import 'vue-color-kit/dist/vue-color-kit.css'
  import { Input, Button, Modal } from 'ant-design-vue'
  import { Palette } from 'lucide-vue-next'
  import { useColorMode } from '@vueuse/core'
  import { useWindowSize } from '@/composables/useWindowSize'

  interface IColorCalculationConfigurationProps {
    modelValue: string
    placeHolder: string
  }

  const props = defineProps<IColorCalculationConfigurationProps>()
  const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

  const colorMode = useColorMode()
  const pickerTheme = computed(() => (colorMode.value === 'dark' ? 'dark' : 'light'))

  const value = ref<string>(props.modelValue || '#59c7f9')

  watch(
    () => props.modelValue,
    (newVal) => {
      value.value = newVal
    }
  )

  watch(value, (newVal) => {
    emit('update:modelValue', newVal)
  })

  const showColorPicker = ref(false)
  const suckerCanvas = ref<any>(null)
  const suckerArea = ref<any[]>([])

  const swatches = [
    '#000000',
    '#FF0000',
    '#00FF00',
    '#0000FF',
    '#FFFF00',
    '#FF00FF',
    '#00FFFF',
    '#FFFFFF'
  ]

  function changeColor(newColor: any) {
    value.value = newColor.hex
  }

  const openSucker = (isOpen: boolean) => {
    if (isOpen) {
      // ... canvas be created
      // suckerCanvas.value = canvas
      // suckerArea.value = [x1, y1, x2, y2]
    } else {
      // suckerCanvas.value && suckerCanvas.value.remove()
    }
  }

  function openColorPicker() {
    showColorPicker.value = true
  }

  function closeColorPicker() {
    showColorPicker.value = false
  }
  const { controlSize } = useWindowSize()
</script>

<template>
  <div class="flex items-center gap-2">
    <Input
      v-model:value="value"
      :placeholder="placeHolder"
      style="width: 120px"
      :size="controlSize"
    />
    <div
      :style="{
        width: '15px',
        height: '15px',
        border: '1px solid #CFCFCF',
        backgroundColor: value,
        marginLeft: '-32px',
        zIndex: 100
      }"
    ></div>
    <Button
      type="primary"
      shape="circle"
      @click="openColorPicker"
      :title="'Pick color'"
      class="color-picker-btn"
    >
      <span class="block">
        <Palette class="h-4 w-4" />
      </span>
    </Button>
    <Modal
      v-model:open="showColorPicker"
      wrapClassName="color-picker-modal-wrapper"
      title=""
      :footer="null"
      width="300px"
      @cancel="closeColorPicker"
      centered
      destroyOnClose
    >
      <ColorPicker
        class="calculation-color-picker"
        :theme="pickerTheme"
        :color="value"
        :colors-default="swatches"
        :sucker-hide="true"
        :sucker-canvas="suckerCanvas"
        :sucker-area="suckerArea"
        @changeColor="changeColor"
        @openSucker="openSucker"
      />
    </Modal>
  </div>
</template>

<style>
  .color-picker-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    margin-left: 10px;
    min-width: 30px;
    min-height: 30px;
    width: 30px;
    height: 30px;
    border-width: 1px !important;
  }

  .hu-color-picker.calculation-color-picker {
    width: 220px !important;
    box-shadow: none;
  }
</style>
